import { withStyles } from '@material-ui/core';
import { compose } from 'recompose';

import Description from './component';
import styles from './styles';

export default compose(withStyles(styles))(Description);
